import { Space, Typography } from 'antd'
import { useProjectSettingsContext } from '../../../../../../ProjectSettingsContext'
import CIMSBasicFields from 'components/CIMSBasicFields'
import { HelpMessage } from 'utils/constants'
import { IFIReportType } from '@cims-online/shared'
import { dateFormatter } from 'utils/dateFormatter'

const Help = HelpMessage.Administration.ProjectSettings.IFITracker
const {
  defaultMessages: { message },
} = IFIReportType.DensityTest

export const DensityTestViewPanel: React.VFC = () => {
  const {
    densityTestIFISettings: { data },
  } = useProjectSettingsContext()

  return (
    <Space direction="vertical" size="middle" style={{ width: '100%' }}>
      <Typography>
        If the Average Percent is less than the Material Requirement's Lot
        Compaction Requirement, use the Message to issue an Identified Field
        Issue. Messages will always be followed by the actual and expected
        values.
      </Typography>
      <CIMSBasicFields
        fields={[
          {
            label: 'Effective Date',
            help: Help.EffectiveDate,
            children: dateFormatter.simple(data?.effectiveDate),
          },
          {
            label: 'Message',
            help: Help.FailureMessage(),
            children: data?.message ?? message,
          },
        ]}
      />
    </Space>
  )
}
